// Generated by scripts/generate-google-env.mjs — do not edit, do not commit.
// Local source: .env (GOOGLE_CLIENT_ID). CI source: GitHub Environments variable.
export const GOOGLE_CLIENT_ID = '283960735654-k1qg93p8mbp7vd0tasfmgkh0ugpm884f.apps.googleusercontent.com';
